import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import type { QueryOptions } from "@/shared/lib/tanstack-query";
import {
  type UseQueryResult,
  useQueries,
  useQuery,
} from "@tanstack/react-query";
import { FreightMatching } from "@x-mile/api-contract";
import type { GetCompanyByIdParams } from "../model";

export const useGetCompanyById = (
  params: GetCompanyByIdParams,
  options?: QueryOptions<typeof FreightMatching.useGetCompanyById>,
): UseQueryResult<FreightMatching.GetCompanyByIdQueryResult, undefined> => {
  const authHeaders = getAuthHeaders();
  const result = useQuery({
    ...options,
    queryKey: ["getCompanyById", keysToSnakeCase(params)],
    queryFn: () =>
      FreightMatching.getCompanyById(
        params.id,
        // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する

        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return result as UseQueryResult<
    FreightMatching.GetCompanyByIdQueryResult,
    undefined
  >;
};

export const useMultipleGetCompanyById = (
  paramsList: { [key: string | number]: GetCompanyByIdParams },
  options?: QueryOptions<typeof FreightMatching.useGetCompanyById> & {
    sortFunc?: (a: GetCompanyByIdParams, b: GetCompanyByIdParams) => number;
  },
): {
  [key: string | number]: UseQueryResult<
    FreightMatching.GetCompanyByIdQueryResult,
    undefined
  >;
} => {
  const authHeaders = getAuthHeaders();
  const keys = Object.keys(paramsList);
  const sortedKeys = options?.sortFunc
    ? keys.sort((a, b) =>
        options?.sortFunc ? options.sortFunc(paramsList[a], paramsList[b]) : 0,
      )
    : keys;
  const result = useQueries({
    queries: sortedKeys.map((key) => {
      const params = paramsList[key];
      return {
        ...options,
        queryKey: ["getCompanyById", keysToSnakeCase(params)],
        queryFn: () =>
          FreightMatching.getCompanyById(
            params.id,
            // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する

            {
              headers: authHeaders.isOk() ? authHeaders.value : {},
            },
          ),
      };
    }),
  });
  const resultByKeys = Object.fromEntries(
    keys.map((key, i) => [key, result[i]]),
  );
  return resultByKeys as {
    [key: string | number]: UseQueryResult<
      FreightMatching.GetCompanyByIdQueryResult,
      undefined
    >;
  };
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const useGetCompanyByIdMock = (
//   params: GetCompanyByIdParams,
//   options?: QueryOptions<typeof FreightMatching.useGetCompanyById>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetCompanyByIdMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useGetCompanyById(params, {
//     enabled: workerStarted && options?.enabled,
//   });
// };

// export const useMultipleGetCompanyByIdMock = (
//   paramsList: { [key: string | number]: GetCompanyByIdParams },
//   options?: QueryOptions<typeof FreightMatching.useGetCompanyById>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getGetCompanyByIdMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useMultipleGetCompanyById(paramsList, {
//     enabled: workerStarted && options?.enabled,
//   });
// };
